var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react'; // tslint:disable-line

import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('content');
import { breakpoints, theme } from '@shapeable/theme';
import { useComponentColor } from '../../hooks/use-component-color';
export var ContentDefaultProps = {
  bullets: 'primary',
  color: 'text'
}; // -------- Styles -------->

export var ContentStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n\n  "], ["\n    ", "\n\n  "])), function (_a) {
    var bulletColor = _a.bulletColor,
        h1Color = _a.h1Color,
        h2Color = _a.h2Color,
        h3Color = _a.h3Color,
        h4Color = _a.h4Color,
        h5Color = _a.h5Color,
        h6Color = _a.h6Color,
        boldColor = _a.boldColor,
        linkColor = _a.linkColor,
        hrColor = _a.hrColor,
        linkHoverColor = _a.linkHoverColor,
        tableBorderColor = _a.tableBorderColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n      a {\n        color: ", ";\n        font-weight: 400;\n        text-decoration: none;\n        \n        &:hover {\n          color: ", ";\n        }\n      }\n\n      img {\n        max-width: 100%;\n      }\n\n      table {\n        border-collapse: collapse;\n        margin-bottom: ", ";\n      }\n\n      td, th {\n        padding: ", ";\n        border: 1px solid ", ";\n      }\n\n      th {\n        background-color: #EFEEEE;\n        font-weight: 600;\n        text-align: left;\n      }\n\n      strong, b {\n        font-weight: 500;\n        color: ", ";\n      }\n\n      h1 {\n        color: ", ";\n      }\n      \n      h2 {\n        color: ", ";\n      } \n      \n      h3 {\n        color: ", ";\n      } \n      \n      h4 {\n        color: ", ";\n      } \n      \n      h5 {\n        color: ", ";\n      } \n      \n      h6 {\n        color: ", ";\n      }\n\n      h1, h2, h3, h4, h5, h6 {\n        font-family: ", ";\n        margin-bottom: 1em;\n        font-weight: 500;\n        line-height: 1.25em;\n      }\n\n      hr {\n        border: none;\n        border-top: 1px solid ", ";\n        height: 0px;\n        font-size: 0;\n        margin: ", " 0;\n      }\n\n      h1 {\n        font-size: 1.25em;\n        background-position: bottom left;\n        padding-bottom: 0.35em;\n        font-weight: 300;\n      }\n\n      h2 {\n        margin-top: 2em;\n        background-position: bottom left;\n        font-size: 1.15em;\n      }\n\n      h3 {\n        margin-top: 2em;\n        font-size: 1.05em;\n      }\n\n      h4 {\n        font-size: 1.0em;\n        margin-bottom: 1em;\n        margin-top: 2em;\n      }\n    \n      h5, h6 {\n        font-size: 0.9em;\n      }\n\n      ul, ol, p {\n        margin-top: 0;\n        margin-bottom: 1.5em;\n      }\n\n      ol {\n        list-style-type: decimal;\n      }\n\n      ul, ol {\n        padding-left: 1em;\n        position: relative;\n        margin-bottom: 1.75em;\n      } \n\n      ol {\n        list-style: decimal;\n        margin-left: ", ";\n      }\n\n      ul {\n        list-style: none;\n        margin-left: ", ";\n      }\n\n      ul li,\n      ol li {\n        position: relative;\n        padding-left: ", ";\n        margin-bottom: 1em;\n      }\n  \n      li ul,\n      li ul:last-child {\n        margin-top: 0.5em;\n        margin-bottom: 2.5em;\n      }\n\n      /* Colored list bullets */\n\n      ul li::before {\n        color: ", ";\n        content: \"\u2022\";\n        font-family: sans-serif;\n        font-size: 22px;\n        position: absolute;\n        left: -0.8em;\n        top: 0.1em;\n      }\n\n      ol, ul, p {\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    \n    "], ["\n\n      a {\n        color: ", ";\n        font-weight: 400;\n        text-decoration: none;\n        \n        &:hover {\n          color: ", ";\n        }\n      }\n\n      img {\n        max-width: 100%;\n      }\n\n      table {\n        border-collapse: collapse;\n        margin-bottom: ", ";\n      }\n\n      td, th {\n        padding: ", ";\n        border: 1px solid ", ";\n      }\n\n      th {\n        background-color: #EFEEEE;\n        font-weight: 600;\n        text-align: left;\n      }\n\n      strong, b {\n        font-weight: 500;\n        color: ", ";\n      }\n\n      h1 {\n        color: ", ";\n      }\n      \n      h2 {\n        color: ", ";\n      } \n      \n      h3 {\n        color: ", ";\n      } \n      \n      h4 {\n        color: ", ";\n      } \n      \n      h5 {\n        color: ", ";\n      } \n      \n      h6 {\n        color: ", ";\n      }\n\n      h1, h2, h3, h4, h5, h6 {\n        font-family: ", ";\n        margin-bottom: 1em;\n        font-weight: 500;\n        line-height: 1.25em;\n      }\n\n      hr {\n        border: none;\n        border-top: 1px solid ", ";\n        height: 0px;\n        font-size: 0;\n        margin: ", " 0;\n      }\n\n      h1 {\n        font-size: 1.25em;\n        background-position: bottom left;\n        padding-bottom: 0.35em;\n        font-weight: 300;\n      }\n\n      h2 {\n        margin-top: 2em;\n        background-position: bottom left;\n        font-size: 1.15em;\n      }\n\n      h3 {\n        margin-top: 2em;\n        font-size: 1.05em;\n      }\n\n      h4 {\n        font-size: 1.0em;\n        margin-bottom: 1em;\n        margin-top: 2em;\n      }\n    \n      h5, h6 {\n        font-size: 0.9em;\n      }\n\n      ul, ol, p {\n        margin-top: 0;\n        margin-bottom: 1.5em;\n      }\n\n      ol {\n        list-style-type: decimal;\n      }\n\n      ul, ol {\n        padding-left: 1em;\n        position: relative;\n        margin-bottom: 1.75em;\n      } \n\n      ol {\n        list-style: decimal;\n        margin-left: ", ";\n      }\n\n      ul {\n        list-style: none;\n        margin-left: ", ";\n      }\n\n      ul li,\n      ol li {\n        position: relative;\n        padding-left: ", ";\n        margin-bottom: 1em;\n      }\n  \n      li ul,\n      li ul:last-child {\n        margin-top: 0.5em;\n        margin-bottom: 2.5em;\n      }\n\n      /* Colored list bullets */\n\n      ul li::before {\n        color: ", ";\n        content: \"\u2022\";\n        font-family: sans-serif;\n        font-size: 22px;\n        position: absolute;\n        left: -0.8em;\n        top: 0.1em;\n      }\n\n      ol, ul, p {\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    \n    "])), linkColor, linkHoverColor, theme.UNIT(6), theme.UNIT(2), tableBorderColor, boldColor, h1Color, h2Color, h3Color, h4Color, h5Color, h6Color, theme.FONT('sans'), hrColor, theme.UNIT(8), theme.UNIT(1), theme.UNIT(1), theme.UNIT(1), bulletColor);
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var Content = function Content(props) {
  var children = props.children,
      className = props.className,
      rest = __rest(props, ["children", "className"]);

  var inner = props.html && React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: props.html || ''
    }
  }) || children;
  var linkColor = useComponentColor({
    cls: cls,
    sub: 'link',
    fallbacks: ['link', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-link', 'mid-brand', 'primary']
  });
  var linkHoverColor = useComponentColor({
    cls: cls,
    sub: 'link-hover',
    fallbacks: ['link-hover', 'dark-brand', 'dark', 'primary'],
    invertedFallbacks: ['inverted-link-hover', 'light-brand', 'light', 'primary']
  });
  var h1Color = useComponentColor({
    cls: cls,
    sub: 'h1',
    fallbacks: ['heading', 'dark-brand', 'primary', 'dark'],
    invertedFallbacks: ['inverted-heading', 'light-brand', 'primary', 'light']
  });
  var h2Color = useComponentColor({
    cls: cls,
    sub: 'h2',
    fallbacks: ['heading', 'dark-brand', 'primary', 'dark'],
    invertedFallbacks: ['inverted-heading', 'light-brand', 'primary', 'light']
  });
  var h3Color = useComponentColor({
    cls: cls,
    sub: 'h3',
    fallbacks: ['heading', 'dark-brand', 'primary', 'dark'],
    invertedFallbacks: ['inverted-heading', 'light-brand', 'primary', 'light']
  });
  var h4Color = useComponentColor({
    cls: cls,
    sub: 'h4',
    fallbacks: ['heading', 'dark-brand', 'primary', 'dark'],
    invertedFallbacks: ['inverted-heading', 'light-brand', 'primary', 'light']
  });
  var h5Color = useComponentColor({
    cls: cls,
    sub: 'h5',
    fallbacks: ['heading', 'dark-brand', 'primary', 'dark'],
    invertedFallbacks: ['inverted-heading', 'light-brand', 'primary', 'light']
  });
  var h6Color = useComponentColor({
    cls: cls,
    sub: 'h6',
    fallbacks: ['heading', 'dark-brand', 'primary', 'dark'],
    invertedFallbacks: ['inverted-heading', 'light-brand', 'primary', 'light']
  });
  var bulletColor = useComponentColor({
    cls: cls,
    sub: 'bullet',
    fallbacks: ['mid-brand', 'dark-brand', 'primary', 'dark'],
    invertedFallbacks: ['mid-brand', 'light-brand', 'primary', 'light']
  });
  var tableBorderColor = useComponentColor({
    cls: cls,
    sub: 'table-border',
    fallbacks: ['line-mid', 'line'],
    invertedFallbacks: ['inverted-line-mid', 'inverted-line']
  });
  var hrColor = useComponentColor({
    cls: cls,
    sub: 'hr',
    fallbacks: ['line-mid', 'line'],
    invertedFallbacks: ['inverted-line-mid', 'inverted-line']
  });
  var boldColor = useComponentColor({
    cls: cls,
    sub: 'bold',
    fallbacks: ['dark'],
    invertedFallbacks: ['light']
  });
  return React.createElement(My.Container, __assign({}, rest, {
    linkColor: linkColor,
    linkHoverColor: linkHoverColor,
    h1Color: h1Color,
    h2Color: h2Color,
    h3Color: h3Color,
    h4Color: h4Color,
    h5Color: h5Color,
    h6Color: h6Color,
    hrColor: hrColor,
    boldColor: boldColor,
    bulletColor: bulletColor,
    tableBorderColor: tableBorderColor,
    className: cls.name(className)
  }), inner);
};
Content.defaultProps = ContentDefaultProps;
Content.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;